import SnippetIsInvalidError from './snippet-is-invalid-error';

export interface validationCriteriaStructure {
    readonly headerFormat: string[];
}

export default class SnippetValidator {
    constructor(private validationCriteria: validationCriteriaStructure) {}

    assertSnippetIsValid(snippet: any[]): void {
        this.assertSnippetNotEmpty(snippet);
        this.assertSnippetHeaderIsValid(snippet);
    }

    private assertSnippetNotEmpty(snippet: any[]): void {
        if (isEmpty(snippet)) {
            throw new SnippetIsInvalidError('Snippet Is Empty.');
        }
    }

    private assertSnippetHeaderIsValid(snippet: any[]): void {
        const [header = []] = snippet;
        const {headerFormat} = this.validationCriteria;

        if (headerFormat.length > header.length) {
            throw new SnippetIsInvalidError('Snippet Header Is Invalid.');
        }

        headerFormat.map((cellContent, index) => {
            if (cellContent !== header[index].trim()) {
                throw new SnippetIsInvalidError('Snippet Header Is Invalid.');
            }
        });
    }
}
